import { apiClient } from './api';
import { 
  EstimateListResponse, 
  EstimateResponse, 
  EstimateCreate, 
  EstimateUpdate,
  EstimateSearchFilters,
  EstimateStatusUpdate,
  EstimateSendRequest
} from '../types/estimate';

export class EstimateService {
  private baseUrl = '/admin/estimates';

  async getEstimates(params: EstimateSearchFilters & { page?: number; per_page?: number }): Promise<EstimateListResponse> {
    const response = await apiClient.get(this.baseUrl, { params });
    return response.data;
  }

  async getEstimate(id: string): Promise<EstimateResponse> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async createEstimate(data: EstimateCreate): Promise<EstimateResponse> {
    const response = await apiClient.post(this.baseUrl, data);
    return response.data;
  }

  async updateEstimate(id: string, data: EstimateUpdate): Promise<EstimateResponse> {
    const response = await apiClient.put(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async deleteEstimate(id: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async updateStatus(id: string, data: EstimateStatusUpdate): Promise<EstimateResponse> {
    const response = await apiClient.patch(`${this.baseUrl}/${id}/status`, data);
    return response.data;
  }

  async sendEstimate(id: string, data: EstimateSendRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/send`, data);
    return response.data;
  }

  async convertToSalesOrder(id: string, conversionData?: any): Promise<{ success: boolean; sales_order_id?: string; message: string }> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/convert`, conversionData);
    return response.data;
  }

  async generatePDF(id: string): Promise<Blob> {
    const response = await apiClient.get(`${this.baseUrl}/${id}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export const estimateService = new EstimateService();